import { render, staticRenderFns } from "./QaAddressComponent.vue?vue&type=template&id=edccd310"
import script from "./QaAddressComponent.vue?vue&type=script&lang=js"
export * from "./QaAddressComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../HCP/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports